<template>
    <Dialog v-model:visible="visible" :style="{ width: '450px' }" header="Create a new DataSource" :modal="true" :dismissableMask="true" @hide="$emit('hide-dialog', true)">
        <div class="p-fluid">
            <div class="field flex">
                <label for="shared_datasource_check">Make it as shared datasource</label>
                <Checkbox id="shared_datasource_check" class="mx-2" v-model="dataSource.sharable" :binary="true" />
            </div>
            <div class="field">
                <label for="name">Name</label>
                <InputText maxlength = "255" id="name" :class="{ 'p-invalid': submitted && !dataSource.name }" v-model="dataSource.name" placeholder="Enter datasource name" />
                <small id="nameError" class="p-invalid" v-if="submitted && !dataSource.name">DataSource Name is required.</small>
            </div>
            <div class="field">
                <label for="code">Code</label>
                <InputText maxlength = "255" id="code" :class="{ 'p-invalid': submitted && !dataSource.code }" v-model="dataSource.code" placeholder="Enter unique datasource code" />
                <small class="p-invalid" v-if="submitted && !dataSource.code">DataSource Code is required. </small>
                <small id="nameError2" class="p-invalid" v-if="submitted && dataSource.code && !isAlphaNumOnly(dataSource.code)">Code needs to be alphanumeric only.</small>
            </div>
            <div class="field">
                <label for="description">Description</label>
                <Textarea id="description" rows="4" v-model="dataSource.description" />
            </div>
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="mx-1 p-button-danger" @click="emit('hide-dialog', true)" />
            <Button label="Submit" icon="pi pi-check" class="mx-1" @click="configure" />
        </template>
    </Dialog>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { storeToRefs } from 'pinia';

import { useDataSourceStore } from '../store';
import { isAlphaNumOnly } from '../../../../../helpers/text-formatter';
import { useRouter } from 'vue-router';
import { LogicalOperation } from '@/products/pha/modules/datasource/enums';

const emit = defineEmits(['hide-dialog']);
const router = useRouter();
const dataSourceStore = useDataSourceStore();
const { dataSource } = storeToRefs(dataSourceStore);

// states
const submitted = ref(false);
const visible = ref(true);

// actions
const configure = async () => {

    /**
     * For an un-known reason, when the last link item (usually with a procedure, is removed,
     * the page lost the datasource id (that the user was amending) leading to errors.
     *
     * Temporary fix:
     * The last link cannot be removed
     * When a new Datasource is created, a link (with user profile FALSE) is added.
     */

    if (typeof dataSource.value !== 'undefined') {
        if (typeof dataSource.value.links !== 'undefined') {
            dataSource.value.links.forEach(item => {
                //console.log('item', item)
                item.logical_operation = LogicalOperation.AND
                item.links = [{
                    type: "procedure",
                    value: "0",
                    procedure: "user_profile"
                },]
            })
        }
    }

    //console.log('dataSource', dataSource.value.links[0].links);

    // debugger;
    submitted.value = true;
    if (isValid()) {
        // Submit datasource and then
        const createdDataSourceId = await dataSourceStore.addDataSource();
        // redirect to links setup
        if (createdDataSourceId) {
            router.push({ name: 'DataSourceUpdate', params: { id: createdDataSourceId } });
        }
    }
};
// helpers
const isValid = () => {
    // debugger;
    if (!dataSource.value.name || !dataSource.value.code || !isAlphaNumOnly(dataSource.value.code)) {
        return false;
    }
    return true;
};
</script>
